// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".DateInputs-module-dateInputsContainer-3K0KO{display:flex;justify-content:center;align-items:flex-start;gap:var(--des-dimension-gap-and-padding-field-vertical-padding)}[dir=rtl] .DateInputs-module-dateInput-3b20-{direction:rtl}.DateInputs-module-input-tAVGt{width:100%}", ""]);
// Exports
exports.locals = {
	"dateInputsContainer": "DateInputs-module-dateInputsContainer-3K0KO",
	"dateInput": "DateInputs-module-dateInput-3b20-",
	"input": "DateInputs-module-input-tAVGt"
};
module.exports = exports;
